var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "soundcloud_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21853",
    transform: "translate(1061 206)",
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1061 -206)",
    clipPath: "url(#soundcloud_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23025",
    d: "M1063.69 222.311a.692.692 0 01-.69-.69v-1.379a.69.69 0 011.379 0v1.379a.692.692 0 01-.69.69"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23026",
    d: "M1066.449 222.311a.692.692 0 01-.69-.69v-2.762a.69.69 0 011.379 0v2.759a.692.692 0 01-.69.69"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23027",
    d: "M1069.207 222.311a.692.692 0 01-.69-.69v-4.138a.69.69 0 111.379 0v4.138a.692.692 0 01-.69.69"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23028",
    d: "M1071.966 222.311a.787.787 0 01-.69-.862v-5.173a.707.707 0 111.379 0v5.173a.787.787 0 01-.69.862"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23029",
    d: "M1080.587 222.311a2.414 2.414 0 000-4.828 2.139 2.139 0 00-.793.138 4.811 4.811 0 00-4.724-3.931 5.266 5.266 0 00-1.034.1v8.518h6.552z"
  }))));
}
export default SvgSoundcloud;